import React from "react";
import { Navigate } from "react-router-dom";
import { ToolName, isToolEnabled, useTools } from "../hooks/useTools";

/** A tool's page: sends the user to the dashboard when the tool is off in Settings > Tools */
const ToolRoute = ({
  tool,
  children,
}: {
  tool: ToolName;
  children: React.ReactNode;
}) => {
  const { data, isPending } = useTools();
  // Wait for the settings, so a reload of a tool's page doesn't bounce off a default
  if (isPending) return null;
  return isToolEnabled(data, tool) ? <>{children}</> : <Navigate to="/" replace />;
};

export default ToolRoute;
